import React, { FC } from 'react';
import { O365Button, SmartSchoolButton } from './login-buttons';
import { Theme, styled } from '@material-ui/core';

const LoginButtonWrapper = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
  margin: '4.5rem 7rem 0 7rem',
  [theme.breakpoints.down('xs')]: {
    margin: '4.5rem 3rem 0 3rem',
  },
}));

const LoginButtons: FC<React.AllHTMLAttributes<HTMLDivElement>> = (props) => {
  return (
    <LoginButtonWrapper {...props}>
      <SmartSchoolButton />
      <O365Button />
    </LoginButtonWrapper>
  );
};

export default LoginButtons;
